<template>
    <div class="container-fluid">
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">シフト表</li>
          </ol>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 pr-10">
          <VCalendar borderless class="calendar-container" />
          <VDatePicker v-model="date" />
        </div>
        <div class="col-md-9">
          <div class="card">
            <div class="card-body">
              <FullCalendar class="calendar-container" id="calendar" :options="calendarOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script setup>
import FullCalendar from '@fullcalendar/vue3'
import VCalendar from 'v-calendar'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import luxonPlugin from '@fullcalendar/luxon'
import locale from '@fullcalendar/core/locales/ja'
import { computed } from 'vue'

const resources = [
  { id: 0, title: 'ケア一覧' },
  { id: 1, title: 'パターン1' },
  { id: 2, title: 'パターン2' },
  { id: 3, title: 'パターン3' },
  { id: 4, title: 'パターン4' },
  { id: 5, title: 'パターン5' }
]

const events = [
  {
    id: 0,
    title: '田中 太朗',
    resourceId: 0,
    date: '2020-04-28 11:00:00'
  },
  {
    id: 1,
    title: '佐藤 二郎',
    resourceId: 0,
    date: '2020-04-28 11:30:00'
  },
  {
    id: 2,
    title: '山田 花子',
    resourceId: 0,
    date: '2020-04-28 11:30:00'
  },
  {
    id: 3,
    title: '鈴木 一郎',
    resourceId: 0,
    date: '2020-04-28 11:30:00'
  },
  {
    id: 4,
    title: '斎藤 三郎',
    resourceId: 0,
    date: '2020-04-28 11:30:00'
  }
]

// Xử lý sự kiện khi click vào nút "プラン追加"
const handleAddPlan = () => {
  // TODO: Implement adding plan functionality
}

// Xử lý sự kiện khi click vào nút "スタッフ表示"
const handleStaffView = () => {
  // TODO: Implement staff view functionality
}

// Calendar options as a computed property
const calendarOptions = computed(() => {
  return {
    schedulerLicenseKey: process.env.VUE_APP_SCHEDULER_LICENSE_KEY,
    locale: locale,
    initialView: 'resourceTimeGridDay',
    timeZone: 'Asia/Tokyo',
    plugins: [luxonPlugin, interactionPlugin, resourceTimeGridPlugin],
    headerToolbar: {
      left: 'addPlan',
      center: 'title',
      right: 'prev,next,showStaffiView'
    },
    customButtons: {
      addPlan: {
        text: 'プラン追加',
        click: handleAddPlan
      },
      showStaffiView: {
        text: 'スタッフ表示',
        click: handleStaffView
      }
    },
    resources: resources,
    events: events,
    allDaySlot: false,
    editable: true,
    eventLimit: true,
    droppable: true,
    datesAboveResources: true
  }
})
</script>

  <style lang="scss">
  .fc th.fc-widget-header {
    padding: 7px 4.5px !important;
  }
  .vc-arrow,
  .vc-title {
    background: transparent;
  }
  .fc-addPlan-button,
  .fc-showStaffiView-button {
    background: white !important;
    border: 1px solid rgba(120, 130, 140, 0.13) !important;
    color: #99abb4 !important;
    border-radius: 5px !important;
    padding: 5px 10px !important;
    cursor: pointer !important;
  }
  </style>
  <style lang="scss" scoped>
  </style>
